.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
  min-height: var(--size-control-sm);
}

.label {
  cursor: pointer;
  user-select: none;
}

.track {
  position: relative;
  display: inline-flex;
  flex-shrink: 0;
  width: calc(var(--size-icon) * 2);
  height: var(--size-icon-lg);
  padding: var(--space-0-5);
  border: 1px solid var(--color-border-strong);
  border-radius: var(--radius-full);
  background: var(--color-surface-sunken);
  transition: background-color var(--duration-fast) var(--ease-standard);
}

.track[data-state="checked"] {
  border-color: var(--color-accent);
  background: var(--color-accent);
}

.track:disabled {
  opacity: 0.5;
}

.thumb {
  display: block;
  width: calc(var(--size-icon-lg) - var(--space-1) - 2px);
  height: calc(var(--size-icon-lg) - var(--space-1) - 2px);
  border-radius: var(--radius-full);
  background: var(--color-fg-muted);
  transition: transform var(--duration-fast) var(--ease-standard);
}

.track[data-state="checked"] .thumb {
  background: var(--color-accent-fg);
  transform: translateX(calc(var(--size-icon) * 2 - var(--size-icon-lg)));
}
